// @flow

import { connect } from 'react-redux';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import GridList from '@material-ui/core/GridList';
import Typography from '@material-ui/core/Typography';
import GridListTile from '@material-ui/core/GridListTile';
import Avatar from '@material-ui/core/Avatar';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Button from '@material-ui/core/Button';
import WbIncandescent from '@material-ui/icons/WbIncandescent';
import { withTranslation } from 'react-i18next';

import Offline from '../../components/Offline';
import {
  reconnectToWebSocket,
  switchWebProduct,
  switchPlatform,
} from '../../actions';
import Loading from '../../components/Loading';
import SwitchFooterContainer from '../../components/SwitchFooterContainer';
import { isDefaultRoomId } from '../../utils/ws-v1';

const mapStateToProps = ({
  scribeTranscriptUI: { fullScreen },
  scribeSession: { socketConnected, loading, displayable },
  scribeDashboard: { rooms },
}) => ({
  displayable,
  fullScreen,
  loading,
  rooms,
  socketConnected,
});

const domainRegex = /http(?:s)?:\/\/([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+(:[0-9]+)?([/][^#/]*)?/gi;
const currentDomain = window.location.href.match(domainRegex)[0];

const getBadgeColor = b => {
  switch (b) {
    case 'gc-asr':
    case 'gc-video-asr':
      return 'steelblue';
    case 'group':
    case 'private':
    case 'public-muted':
    case 'public':
      return 'darksalmon';
    default:
      return 'green';
  }
};

// eslint-disable-next-line  react/prefer-stateless-function
class Room extends React.Component<
  { status: Object, theme: Object, t: Function },
  {}
> {
  render() {
    const { status, theme, t } = this.props;
    if (!status) {
      return null;
    }
    let link = status.links.rw;
    link = link.replace(/^https:\/\/dev.avascribe.com\//, currentDomain);
    link = link.replace(/^https:\/\/app-stage.ava.me\//, currentDomain);
    link = link.replace(/^https:\/\/app.avascribe.com\//, currentDomain);
    link = link.replace(/^https:\/\/app.ava.me\//, currentDomain);
    link = link.replace(/^https:\/\/web.ava.me\//, currentDomain);
    link = `${link}&scribe=1`;

    let scribed;
    let leaving;
    if (status.scribe && status.scribe.status === 'ongoing') {
      scribed = true;
    }
    if (status.scribe && status.scribe.status === 'leaving') {
      leaving = true;
    }
    const host = status.participants.find(
      p => p.avaId === status.id.split('_')[0]
    );
    const badges = [];
    if (status.asr && status.asr.googleCloud) {
      badges.push('gc-asr');
    }
    if (status.asr && status.asr.googleCloudVideo) {
      badges.push('gc-video-asr');
    }
    // eslint-disable-next-line
    for (let lang of status.langs || []) {
      badges.push(lang);
    }
    badges.push(status.conversationMode);
    if (status && status.links && status.links.ro) {
      badges.push(status.links.ro);
    }

    const diff = Math.round((Date.now() - status.startTimestampMs) / 60 / 1000);
    let ddh = '';
    if (diff >= 60) {
      ddh = `${Math.floor(diff / 60)}h`;
    }
    let ddm = `${Math.round(diff - Math.floor(diff / 60) * 60)}m`;
    if (ddm.length === 2) {
      ddm = `0${ddm}`;
    }
    return (
      <Card
        style={{
          minWidth: 275,
          margin: 20,
          borderWidth: 5,
          // eslint-disable-next-line
          borderColor: scribed ? 'green' : leaving ? 'orange' : 'orangered',
          borderLeftStyle: 'solid',
        }}
      >
        <CardContent style={{ paddingBottom: 0 }}>
          {status.title && (
            <Typography variant="h6">
              <span style={{ textTransform: 'uppercase' }}>{status.title}</span>
            </Typography>
          )}
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <Typography variant="h6" style={{ width: 180 }}>
              {new Date(status.startTimestampMs).toLocaleTimeString()} ({ddh}
              {ddm})
            </Typography>
            <Typography variant="h6" style={{ width: 300 }}>
              {!host && t('noHost')}
              {host && `&${host.avaName} - ${host.userName}`}{' '}
            </Typography>
            <div style={{ flexGrow: 1 }} />
            {badges.map(b => (
              <div
                key={b}
                style={{
                  backgroundColor: getBadgeColor(b),
                  margin: 3,
                  borderRadius: 5,
                  padding: 5,
                  paddingBottom: 1,
                  paddingTop: 1,
                }}
              >
                {b}
              </div>
            ))}
          </div>
          <Typography variant="body2" color="secondary">
            id: {status.id} ||{' '}
            {`${status.status} - ${status.scribe ? status.scribe.status : ''}`}
          </Typography>
          <GridList
            cellHeight={65}
            cols={5}
            style={{
              marginTop: 5,
            }}
          >
            {status.participants.map((p, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <GridListTile key={`${index}-${p.avaId}`}>
                <Card
                  style={{
                    backgroundColor: theme.palette.secondary,
                    borderWidth: 2,
                    borderColor: 'green',
                    borderTopStyle: p.scribe ? 'solid' : undefined,
                  }}
                >
                  <CardHeader
                    title={`&${p.avaName}`}
                    subheader={p.avaId}
                    avatar={<Avatar aria-label="Recipe" src={p.photoUrl} />}
                    style={{ padding: 10 }}
                  />
                </Card>
              </GridListTile>
            ))}
          </GridList>
        </CardContent>
        <CardActions>
          <Button
            style={{ marginRig: 'auto' }}
            variant="outlined"
            href={`https://speech.ava.me/lamp/#/captioner/rooms/${status.id}`}
          >
            <WbIncandescent />
            <span> LAMP </span>
          </Button>
          <Button
            style={{ margin: 'auto' }}
            variant="contained"
            size="small"
            target="_blank"
            href={link}
          >
            {scribed ? 'Help to transcribe' : 'Transcribe'}
          </Button>
        </CardActions>
      </Card>
    );
  }
}

// eslint-disable-next-line
class ScribeDashboard extends React.Component<{
  fullScreen: boolean,
  history: Object,
  loading: boolean,
  reconnectToWebSocket: Function,
  socketConnected: boolean,
  theme: Object,
  rooms: Array<Object>,
  t: Object,
}> {
  render() {
    const {
      history,
      fullScreen,
      loading,
      // eslint-disable-next-line no-shadow
      reconnectToWebSocket,
      socketConnected,
      t,
      theme,
      rooms,
    } = this.props;

    const filteredRooms = rooms.filter(
      status =>
        status.participants.filter(p => p.channel !== '' || p.scribe).length
    );
    if (loading) {
      return <Loading />;
    }
    return (
      <div
        style={{
          padding: 10,
          marginLeft: 'auto',
          marginRight: 'auto',
          maxWidth: 1000,
          minWidth: 750,
          color: theme.palette.primary.light,
        }}
      >
        <Offline
          reconnect={reconnectToWebSocket}
          online={socketConnected === 'CONNECTED'}
          display
        />
        <div
          style={{
            marginTop: fullScreen ? 0 : 67,
          }}
        >
          {filteredRooms
            .sort((a, b) => (a.startTimestampMs < b.startTimestampMs ? 1 : -1))
            .filter(r => !isDefaultRoomId(r.id || ''))
            .map(room => (
              <Room
                theme={theme}
                key={room ? room.id : 'no-id'}
                status={room}
                t={t}
              />
            ))}
          {!filteredRooms.length && (
            <Typography key="title" component="h3" variant="h3" align="center" color="textPrimary">
              {t('noScribeRequest')}.
            </Typography>
          )}
          <SwitchFooterContainer history={history} />
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  {
    reconnectToWebSocket,
    switchWebProduct,
    switchPlatform,
  }
)(withRouter(withTheme(withTranslation()(ScribeDashboard))));
